(() => {
  "use strict";

  const input = document.querySelector("[data-photo-input]");
  const uploadDialog = document.querySelector("[data-upload-review-dialog]");
  const uploadReview = uploadDialog?.querySelector(".upload-review-dialog__media img");
  let reviewUrl = "";
  let pendingFile = null;

  function clearReviewUrl() {
    if (reviewUrl) URL.revokeObjectURL(reviewUrl);
    reviewUrl = "";
  }

  function closeUploadReview({ clearInput = false, chooseAnother = false } = {}) {
    if (uploadDialog?.open) uploadDialog.close();
    clearReviewUrl();
    pendingFile = null;
    if (clearInput && input) input.value = "";
    if (chooseAnother) input?.click();
  }

  function openUploadReview(file) {
    if (!uploadDialog || !uploadReview || !file) return;
    pendingFile = file;
    clearReviewUrl();
    reviewUrl = URL.createObjectURL(file);
    uploadReview.src = reviewUrl;
    if (uploadDialog.open) uploadDialog.close();
    try {
      uploadDialog.showModal();
    } catch {
      uploadDialog.setAttribute("open", "");
    }
  }

  input?.addEventListener("change", () => {
    const file = input.files?.[0];
    if (file) openUploadReview(file);
  });
  uploadDialog?.querySelector("[data-upload-review-close]")?.addEventListener("click", () => closeUploadReview({ clearInput: true }));
  uploadDialog?.querySelector("[data-upload-review-change]")?.addEventListener("click", () => closeUploadReview({ clearInput: true, chooseAnother: true }));
  uploadDialog?.addEventListener("cancel", (event) => {
    event.preventDefault();
    closeUploadReview({ clearInput: true });
  });
  uploadDialog?.querySelectorAll("[data-upload-review-generate]").forEach((button) => {
    button.addEventListener("click", () => {
      if (!pendingFile) return;
      const file = pendingFile;
      const mode = button.dataset.uploadReviewGenerate === "enhanced" ? "enhanced" : "quick";
      if (uploadDialog.open) uploadDialog.close();
      clearReviewUrl();
      pendingFile = null;
      input.dispatchEvent(new CustomEvent("formofus:photo-confirmed", { detail: { file, mode } }));
      document.querySelector("[data-generate-button]")?.focus();
    });
  });

  const thumbs = document.querySelector("[data-product-thumbs]");
  const mainImage = document.querySelector("[data-product-image]");
  const galleryStory = document.querySelector("[data-gallery-story]");
  thumbs?.addEventListener("click", (event) => {
    const button = event.target.closest("[data-gallery-image]");
    if (!button || !mainImage) return;
    mainImage.src = button.dataset.galleryImage;
    mainImage.alt = button.dataset.galleryAlt || mainImage.alt;
    thumbs.querySelectorAll("button").forEach((item) => item.classList.toggle("active", item === button));
    if (galleryStory) {
      const title = button.dataset.galleryTitle || "";
      const body = button.dataset.galleryBody || "";
      galleryStory.hidden = !title;
      galleryStory.querySelector("[data-gallery-title]").textContent = title;
      galleryStory.querySelector("[data-gallery-body]").textContent = body;
    }
  });

  const lightbox = document.querySelector("[data-image-lightbox]");
  document.querySelector("[data-image-zoom]")?.addEventListener("click", () => {
    if (!lightbox || !mainImage) return;
    lightbox.querySelector("img").src = mainImage.src;
    lightbox.showModal();
  });
  document.querySelector("[data-image-lightbox-close]")?.addEventListener("click", () => lightbox.close());

  const customizeBox = document.querySelector(".customization-box");
  document.querySelectorAll("[data-sticky-customize], [data-scroll-customize]").forEach((button) => button.addEventListener("click", () => {
    customizeBox?.scrollIntoView({ behavior: "smooth", block: "center" });
  }));

  const menuToggle = document.querySelector("[data-menu-toggle]");
  const nav = document.querySelector("#primary-nav");
  menuToggle?.addEventListener("click", () => {
    const open = nav?.classList.toggle("open");
    menuToggle.setAttribute("aria-expanded", String(Boolean(open)));
  });

  const searchDialog = document.querySelector("[data-search-dialog]");
  document.querySelector("[data-search-open]")?.addEventListener("click", () => searchDialog?.showModal());

})();
